import { FaCar, FaCalendarCheck, FaKey, FaRoad } from 'react-icons/fa';

const process = [
    {
        id: 1,
        icon: <FaCar />, // Car Selection Icon
        title: 'Choose Your Car',
        content: 'Browse our wide range of vehicles and select the perfect car for your journey.',
    },
    {
        id: 2,
        icon: <FaCalendarCheck />, // Booking Icon
        title: 'Book Online',
        content: 'Reserve your car through our simple online booking system with flexible rental options.',
    },
    {
        id: 3,
        icon: <FaKey />, // Pickup Icon
        title: 'Pick Up Your Car',
        content: 'Visit our location or opt for delivery service to receive your rental car hassle-free.',
    },
    {
        id: 4,
        icon: <FaRoad />, // Enjoy Ride Icon
        title: 'Enjoy Your Ride',
        content: 'Drive comfortably with 24/7 support, and return the car at your convenience.',
    },
];

export default process;